/**
 * Recursively retrieves all unique translated names for nodes in a tree structure based on the specified language.
 *
 * @param {Object} root - The root node or nodes of the tree, where each node may contain a `translations` object and `children`.
 * @param {string} lang - The language code to retrieve the translated names for.
 * @returns {string[] | null} An array of unique translated names in the specified language, or null if root or lang is not provided.
 */
const getNodesNamesByLanguage = (root, lang) => {
  if (!root || !lang) return null

  const names = []
  Object.values(root).forEach((node) => {
    const translatedName = node?.translations?.[lang]
    if (translatedName && translatedName.trim() !== '') {
      names.push(translatedName)
    }

    if (node?.children) {
      names.push(...getNodesNamesByLanguage(node.children, lang))
    }
  })

  return [...new Set(names)]
}

export default getNodesNamesByLanguage
